import React, { useState } from 'react';

/**
 * A jornada do lead: por onde a pessoa passou antes de preencher.
 *
 * Vem gravada dentro do próprio lead, copiada pela função de captação. A leitura
 * mais importante está nas duas primeiras linhas: PRIMEIRO contato e ÚLTIMO.
 * Quando os dois discordam, o crédito da venda estava indo para o canal errado.
 */
const CANAL_ICONE = {
  'Google Ads': '🔍',
  'Meta Ads': '📱',
  'Busca orgânica': '🌱',
  'Busca com IA': '🤖',
  'Campanha': '📣',
  'Indicação de outro site': '🔗',
  'Direto': '✳️',
};

function quando(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
}

function semDominio(url) {
  return String(url || '').replace(/^https?:\/\/(www\.)?/, '').replace(/\/$/, '');
}

function JornadaLead({ jornada }) {
  const [aberto, setAberto] = useState(false);
  if (!jornada) return null;

  const { primeiro_canal: primeiro, ultimo_canal: ultimo, toques = 0, sessoes = 1, dias_ate_o_lead: dias = 0, linha = [] } = jornada;
  const mudou = primeiro && ultimo && primeiro !== ultimo;

  return <div className="mb-4 bg-slate-50 border border-slate-200 rounded-xl px-4 py-3">
    <div className="flex items-center justify-between gap-2 flex-wrap">
      <span className="text-xs text-slate-400 font-semibold uppercase tracking-wide">Como chegou até aqui</span>
      {linha.length > 0 && <button type="button" onClick={() => setAberto(a => !a)}
        className="text-xs text-blue-600 hover:text-blue-700 font-medium">
        {aberto ? 'Esconder' : `Ver os ${linha.length === 1 ? 'detalhes' : linha.length + ' passos'}`}
      </button>}
    </div>

    <div className="mt-2 grid sm:grid-cols-2 gap-x-6 gap-y-1 text-sm">
      <div>
        <span className="text-gray-400">Primeiro contato:</span>{' '}
        <span className="font-medium">{CANAL_ICONE[primeiro] || ''} {primeiro || '—'}</span>
      </div>
      <div>
        <span className="text-gray-400">Virou lead vindo de:</span>{' '}
        <span className={`font-medium ${mudou ? 'text-amber-700' : ''}`}>{CANAL_ICONE[ultimo] || ''} {ultimo || '—'}</span>
      </div>
    </div>

    <p className="text-xs text-slate-400 mt-1.5">
      {sessoes} {sessoes === 1 ? 'visita' : 'visitas'} · {toques} {toques === 1 ? 'passo' : 'passos'}
      {dias > 0 && ` · levou ${dias} ${dias === 1 ? 'dia' : 'dias'} para chamar`}
      {dias === 0 && ' · chamou no mesmo dia'}
    </p>

    {mudou && <p className="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-2 py-1 mt-2">
      Começou em {primeiro} e converteu em {ultimo}. Olhando só o último clique, {primeiro} não receberia crédito nenhum.
    </p>}

    {aberto && <ol className="mt-3 space-y-2 border-l-2 border-slate-200 pl-3">
      {linha.map((t, i) => <li key={i} className="text-xs">
        <div className="font-medium text-gray-700">
          {CANAL_ICONE[t.rotulo] || ''} {t.rotulo} <span className="text-gray-400 font-normal">· {quando(t.em)}</span>
        </div>
        {t.pagina && <div className="text-gray-400 break-all">{semDominio(t.pagina)}</div>}
        {t.ref && <div className="text-gray-400 break-all">veio de {semDominio(t.ref)}</div>}
        {t.params && Object.keys(t.params).length > 0 && <div className="text-gray-400 break-all">
          {Object.entries(t.params).slice(0, 6).map(([k, v]) => `${k}=${v}`).join(' · ')}
        </div>}
      </li>)}
    </ol>}
  </div>;
}

export { JornadaLead };
